module.exports = __webpack_public_path__ + "static/media/basketball.8821b44c.webp";